import script from "./MypageSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MypageSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MypageSidebar.vue?vue&type=style&index=0&id=51df571a&scoped=true&lang=scss"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51df571a"]])

export default __exports__